import { gql } from '@apollo/client';
import { ChipProps, GridProps } from '@mui/material';

import { SxStyle } from '../../utils/reactTypes';
import { AxleChip, ChipsInRows } from '../displayFields/chips';

interface IDisciplineChipProps {
    discipline: IDisciplineChip;
    sx?: SxStyle;
}

export interface IDisciplineChip {
    id: string;
    name: string | null;
    displayName: string;
    code: string;
}

export const DisciplineChipFragment = gql`
    fragment DisciplineChipFragment on Discipline {
        id
        name
        displayName
        code
    }
`;

export const DisciplineChip = ({ discipline, ...rest }: IDisciplineChipProps) => {
    return (
        <AxleChip
            label={discipline.displayName}
            tooltip={discipline.name ? `${discipline.name} (${discipline.code})` : discipline.code}
            {...rest}
        />
    );
};

export const DisciplineChips = ({
    disciplines,
    chipProps,
    ...props
}: {
    disciplines: IDisciplineChipProps['discipline'][];
    chipProps?: ChipProps;
} & GridProps) => {
    return (
        <ChipsInRows {...props}>
            {disciplines.map((discipline) => (
                <DisciplineChip key={discipline.id} discipline={discipline} {...chipProps} />
            ))}
        </ChipsInRows>
    );
};
